// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3fmGX","empty":"ModalGraph_empty__1_SbL"};